import * as React from 'react';
import { Layout, Notification, Cell } from '@wix/design-system';
import { useTranslation } from '../../../hooks/use-translation';

export function MarketingIntegrationsToast({
  navigateToMarketingIntegration,
}: {
  navigateToMarketingIntegration: any;
}) {
  const t = useTranslation();
  return (
    <Layout>
      <Cell>
        <Notification show>
          <Notification.TextLabel>
            {t('manage-apps.marketing-integrations-toast.done')}
          </Notification.TextLabel>
          <Notification.ActionButton
            onClick={() => navigateToMarketingIntegration()}
          >
            {t('manage-apps.marketing-integrations-toast.back')}
          </Notification.ActionButton>
          <Notification.CloseButton />
        </Notification>
      </Cell>
    </Layout>
  );
}
